<template>
  <div class="table-page-search-wrapper" id="table-page-search-wrapper">
    <a-form layout="inline">
      <a-row :gutter="48" class="searchRow">
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="仓库名称" v-model="searchModel.name" />
        </a-col>
        <a-col :md="12" :sm="24" class="searchColBtn">
          <span class="table-page-search-submitButtons">
            <a-button class="btn" type="primary" @click="search()">查询</a-button>
            <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            <a-button class="btn btnMarginLeft_12" type="primary" @click="add" v-if="$auth('warehouseManagement.add')">新增</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import processIcon from '@/views/equipmentLedger/modules/processIcon'
import {
  assetTypeList,
  getDeptTreeListInSearch,
  getfocalDepartmentsList,
  getSelectDataList,
  getTreeByRoleUsedeptList
} from '@/api/assetLedger'
import processDropDown from '@/components/ProcessDropDown/ProcessDropDown'
import { delEquipment, getDictList } from '@/api/equipmentLedger'
import { mapGetters } from 'vuex'
export default {
  name: 'SearchForm',
  components: {
    processDropDown,
    processIcon
  },
  data () {
    return {
      btnLoading: false,
      showExpend: false,
      searchModel: {}
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 点击查询按钮
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', model)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}
      this.$emit('clearSearch', this.searchModel)
    },
    // 新增
    add() {
      this.$emit('openModel', 'add')
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  height: 42px;
  overflow: hidden;
  transition: height 300ms ease;
}
.unfold{
  height: 126px;
  //margin-bottom: 10px;
}
.searchRow {
  margin: 0 !important;
  .ant-calendar-picker {
    width: 100%;
  }
}
.searchColInput {
  padding: 0 12px 0 0 !important;
}
.searchColSelect {
  padding: 0 12px 0 0 !important;
}
.searchColBtn {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .table-page-search-submitButtons {
    margin-bottom: 10px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.btn {
  padding: 0 10px !important;
}
.btnMarginLeft_12 {
  margin-left: 10px !important;
}
.btnLoading {
  padding: 0 10px 0 29px !important;
}
.unfoldText {
  color: #1791FF;
  position: relative;
  cursor: pointer;
  width: 48px;
  display: inline-block;
}
.unfoldIcon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 3px;
  right: 4px;
  margin: auto;
  color: #1791FF;
  font-size: 12px;
  line-height: 1;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
/deep/.ant-popover-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
